module.exports = __webpack_public_path__ + "img/icicibank.c557cd6f.png";